module.exports = {
  BASE_URL: BASE_URL,
  api: {
    /* AUTH */
    auth: {
      profile: BASE_URL + "auth/profile/",
      check: BASE_URL + "auth/check/",
      login: BASE_URL + "auth/login/",
      logoff: BASE_URL + "auth/logoff/",
      register: BASE_URL + "auth/register/",
      regenerarPassword: BASE_URL + "auth/regenerarPassword/",
    },
    /* CATALOGO */
    catalogo: {
      filters: BASE_URL + "api/catalogo/filters/",
      filtersOfertas: BASE_URL + "api/catalogo/filters/ofertas/",
      descargarCatalogo: BASE_URL + "api/catalogo/generarXLS/",
      sugerencias: BASE_URL + "api/catalogo/sugerencias/",
      searchOfertas: BASE_URL + "api/catalogo/ofertas/",
      search: BASE_URL + "api/catalogo/",
    },
    /* PEDIDOS */
    pedidos: {
      generar: {
        pedido: BASE_URL + "api/pedidos/generar/pedido/",
        presupuesto: BASE_URL + "api/pedidos/generar/presupuesto/",
        carrito: BASE_URL + "api/pedidos/generar/carrito/",
      },
      pedidos: BASE_URL + "api/pedidos/",
    },
    /* CART */
    cart: {
      base: BASE_URL + "api/cart",
      items: BASE_URL + "api/cart/items",
      itemByCode: BASE_URL + "api/cart/items/by-code/",
    },
    /* PERFIL CLIENTE */
    perfil: {
      recentQueries: BASE_URL + "api/perfil/recentQueries/",
      margenGanancia: BASE_URL + "api/perfil/margenGanancia/",
      resumenCuenta: BASE_URL + "api/perfil/resumenCuenta/",
      lastCart: BASE_URL + "api/perfil/lastCart/",
      saveCart: BASE_URL + "api/perfil/saveCart/",
      perfil: BASE_URL + 'api/perfil/',
    },
    /* SITIO - CUSTOM */
    sitio: {
      getImagesCarrusel: BASE_URL + "api/config/carrusel/",
      descargaComprobantes: BASE_URL + "api/comprobantes/fichero/",
      getImagesPopUp: BASE_URL + "api/config/popup/",
      getPromociones: BASE_URL + "api/config/promociones/",
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js